var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBxSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9997 4.33301C14.0527 4.33301 4.33301 14.0527 4.33301 25.9997V34.9762C4.33301 37.1948 6.27651 38.9997 8.66634 38.9997H10.833C11.4076 38.9997 11.9587 38.7714 12.3651 38.3651C12.7714 37.9587 12.9997 37.4076 12.9997 36.833V25.6898C12.9997 25.1152 12.7714 24.5641 12.3651 24.1578C11.9587 23.7514 11.4076 23.5232 10.833 23.5232H8.86567C10.0703 15.1382 17.2853 8.66634 25.9997 8.66634C34.714 8.66634 41.929 15.1382 43.1337 23.5232H41.1663C40.5917 23.5232 40.0406 23.7514 39.6343 24.1578C39.2279 24.5641 38.9997 25.1152 38.9997 25.6898V38.9997C38.9997 41.3895 37.0562 43.333 34.6663 43.333H30.333V41.1663H21.6663V47.6663H34.6663C39.446 47.6663 43.333 43.7793 43.333 38.9997C45.7228 38.9997 47.6663 37.1948 47.6663 34.9762V25.9997C47.6663 14.0527 37.9467 4.33301 25.9997 4.33301Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxSupport);
export default __webpack_public_path__ + "static/media/bx_support.3d0f6ba8638642646bbc6e11d7bef5ad.svg";
export { ForwardRef as ReactComponent };